import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { Button } from 'components/common';

const FollowUsersViewSelector = () => {
  const { dispatch } = useDispatch();
  const {
    messages,
    pageState: { view }
  } = useReduxState();

  const handleChange = async (view: 'overview' | 'analytics') => {
    dispatch(actions.updatePageState({ view }));
  };

  const isOverview = view === 'overview';

  return (
    <div className="view">
      <Button
        aria-label={messages.commonOverview}
        category="group"
        data-tooltip={messages.commonOverview}
        icon="info-circle"
        iconStyle={{ fontSize: '1.4rem', padding: 0 }}
        isGroupActive={isOverview}
        onClick={() => handleChange('overview')}
        size="header"
      />
      <Button
        aria-label={messages.commonAnalytics}
        category="group"
        data-tooltip={messages.commonAnalytics}
        icon="chart-bar"
        isGroupActive={!isOverview}
        iconStyle={{ fontSize: '1.4rem' }}
        onClick={() => handleChange('analytics')}
        size="header"
      />
    </div>
  );
};

export default FollowUsersViewSelector;
